import React, { useContext, useEffect, useState } from 'react';
import { MdAddShoppingCart } from 'react-icons/md';
// import { IoStorefrontSharp } from "react-icons/io/";
import { GiShop } from 'react-icons/gi';
import { AiOutlineUser } from 'react-icons/ai';
import { SiGooglemessages } from 'react-icons/si';
import { MdMoreHoriz } from 'react-icons/md';
import { AppContext } from '../context/appData';
import '../styles/footermenu.scss';
import { NavLink, useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { _hex2rgba } from '../utils/helpers';
import { ProductContext } from '../context/ProductContext';
import { retailNotificationApi } from '../utils/api/microserviceConfig';
import { microService_url } from '../utils/config';
import apiRequest from '../utils/api/apiRequest';

const StyledNavLink = styled(NavLink)`
  color: rgba(0, 0, 0, 0.55);

  span {
    color: #9aa7c5;
  }

  &:hover {
    color: ${props => `${props.theme.color}`};
    //background-color: ${props => _hex2rgba(props.theme.color, 0.09)};
    span {
      color: ${props => `${props.theme.color}`};
    }
  }

  &.active__page {
    color: ${props => `${props.theme.color}`};
    span {
      color: ${props => `${props.theme.color}`};
    }
  }
`;

const MenuItem = styled.div`
  font-size: 12px;
  font-weight: 400;
`;

const FooterMenu = () => {
  const [notifs, setNotifs] = useState([]);
  const history = useHistory();
  const [toggle, setToggle] = useState(true);
  const productData = useContext(ProductContext);
  const appData = useContext(AppContext);
  // disabling the send bird consumption of sendbird in app
  // const sendBirdData = useContext(SendbirdContext);

  function getItemsCount() {
    let itemsCount = 0;
    if (productData.cartItems && productData.cartItems.length > 0) {
      productData.cartItems.forEach(item => {
        itemsCount = itemsCount + Number(item.Quantity);
      });
      return itemsCount;
    } else {
      return 0;
    }
  }
  const showNotifvalue = () => {
    setToggle(false);
  };

  useEffect(() => {
    getItemsCount();
    async function getnotifs() {
      const result = await apiRequest({
        api: retailNotificationApi,
        method: 'get',
        url: `${microService_url}/notification/api/pull-notifications/retailer`,
      });
      if (!result.error) {
        setNotifs(result);
      }
    }
    getnotifs();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    setToggle(true);
  }, [notifs]);

  return (
    <div className="footer__page">
      <div className={`footer__page__footer`}>
        <div className="relative">
          <div className="flex flex-between align-center px-10">
            <div className="items ">
              <StyledNavLink to="/store" activeClassName="active__page">
                <div>
                  <GiShop size={'1.2rem'} color={'active__page'} />
                  <MenuItem>Store</MenuItem>
                </div>
              </StyledNavLink>

              <StyledNavLink to="/account" activeClassName="active__page">
                <div>
                  <div>
                    <AiOutlineUser size={'1.2rem'} color={'active__page'} />
                    <MenuItem> My account</MenuItem>
                  </div>
                </div>
              </StyledNavLink>
            </div>
            <div className="pointer" onClick={() => history.push('/cart')}>
              <div className="footer__page__cart h-20 w-20 pointer">
                <div
                  className="footer__page__cart__1 pointer"
                  style={{ background: appData.theme.color }}
                >
                  <div className="relative">
                    <div className="absolute p-13">
                      <MdAddShoppingCart color={'#fff'} size={'2rem'} />
                    </div>
                  </div>
                </div>
              </div>
              {getItemsCount() > 0 && (
                <div className="footer__page__cart__count">
                  <div
                    className="footer__page__cart__2"
                    style={{
                      padding: getItemsCount() > 9 ? '2px 4px' : '2px 8px',
                    }}
                  >
                    <span className="cart-count">{getItemsCount()}</span>
                  </div>
                </div>
              )}
            </div>
            <div className="items " onClick={showNotifvalue}>
              <StyledNavLink to="/messages" activeClassName="active__page">
                <div className="relative">
                  <SiGooglemessages size={'1.2rem'} color={'active__page'} />
                  {notifs.length > 0 && toggle && (
                    <div className="footer__page__cart__count">
                      <div
                        className="footer__page__cart__2"
                        style={{
                          padding: notifs.length > 9 ? '2px 4px' : '2px 8px',
                        }}
                      >
                        <span className="cart-count">{notifs.length}</span>
                      </div>
                    </div>
                  )}
                  <MenuItem>Messages</MenuItem>
                </div>
              </StyledNavLink>
              <StyledNavLink to="/menu" activeClassName="active__page">
                <div>
                  <MdMoreHoriz size={'1.2rem'} color={'active__page'} />
                  <MenuItem>Menu</MenuItem>
                </div>
              </StyledNavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterMenu;
